import {
    USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE, USER_LOGOUT,
} from '../constants/login.constants';

const initialState = {
    loading: false,
    authParams: null,
    status: null,
    visible: false,
    error: null,
};

export const Login_form = (state = initialState, action) => {
    switch (action.type) {
    case USER_LOGIN_REQUEST:
        return {
            ...state,
            loading: true,
            authParams: action.authParams,
            status: action.authParams.status,
        };
    case USER_LOGIN_SUCCESS:
        return {
            ...state,
            loading: false,
            authParams: action.authParams,
            visible: false,
        };
    case USER_LOGIN_FAILURE:
        return {
            ...state,
            loading: false,
            authParams: {},
            error: action.error,
        };
    case USER_LOGOUT:
        return {
            ...state,
            loading: false,
            visible: !!action.action,
            error: null,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/login.reducers.js